// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { RadioGroup } from '@/components/ui'
import type { OnboardingData } from '@/types'

const MARITAL_OPTIONS = [
  { value: 'single',     label: 'Ongehuwd' },
  { value: 'married',    label: 'Getrouwd' },
  { value: 'registered', label: 'Geregistreerd partnerschap' },
  { value: 'divorced',   label: 'Gescheiden' },
  { value: 'widowed',    label: 'Weduwe / Weduwnaar' },
]

interface Step6MaritalStatusProps {
  data:     Partial<OnboardingData>
  onChange: (updates: Partial<OnboardingData>) => void
  errors:   Partial<Record<keyof OnboardingData, string>>
}

export function Step6MaritalStatus({ data, onChange, errors }: Step6MaritalStatusProps) {
  return (
    <div className="flex flex-col gap-5">
      <div>
        <h2 className="text-lg font-semibold text-ink mb-1">Burgerlijke staat</h2>
        <p className="text-sm text-ink-3">
          Dit helpt bij het invullen van relevante secties over uw gezinssituatie.
        </p>
      </div>

      <RadioGroup
        name="maritalStatus"
        options={MARITAL_OPTIONS}
        value={data.maritalStatus ?? ''}
        onChange={(v) => onChange({ maritalStatus: v })}
        error={errors.maritalStatus}
      />

      <p className="text-xs text-ink-4 bg-sand px-3.5 py-3 rounded-xl">
        U kunt dit altijd later aanpassen in uw profiel.
      </p>
    </div>
  )
}
